import React from "react";

const PromoBanner = () => (
  <div className="promo-banner" role="note" aria-label="Promotion livraison">
    Livraison offerte dès 150&nbsp;€ d&apos;achat
  </div>
);

export default PromoBanner;